import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as UserService from '../../services/firebase';

const initialState = {
    user: null,
    status: 'idle',
    error: '',
};

/* Login User */
export const LoginUser = createAsyncThunk('user/LoginUser', async (form) => {
    return UserService.login(form);
})

export const LogoutUser = createAsyncThunk('user/LogoutUser', async () => {
    return UserService.logout();
})

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        reset: (state) => {
            state.user = null;
            state.status = 'idle';
            state.error = '';
        },
        authorize: (state, action) => {
            state.user = action.payload;
        }
    },
    extraReducers: {
        [LoginUser.pending]: (state, action) => {
            state.status = 'loading';
        },
        [LoginUser.fulfilled]: (state, action) => {
            state.status = 'succeeded';
            state.user = action.payload;
        },
        [LoginUser.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        },
        [LogoutUser.pending]: (state, action) => {
            state.status = 'loading';
        },
        [LogoutUser.fulfilled]: (state, action) => {
            state.status = 'succeeded';
        },
        [LogoutUser.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        }
    }
});


export const { reset, authorize } = userSlice.actions;
export const selectUser = state => state.user.user;
export const selectUserStatus = state => state.user.status;
export const selectUserError = state => state.user.error;

export default userSlice.reducer;
